export var OnboardingUserType;
(function (OnboardingUserType) {
    OnboardingUserType["SDK_BUILDER"] = "sdk_builder";
    OnboardingUserType["STANDARD_USER"] = "standard_user";
})(OnboardingUserType || (OnboardingUserType = {}));
export var OnboardingStatusValue;
(function (OnboardingStatusValue) {
    OnboardingStatusValue["IN_PROGRESS"] = "in_progress";
    OnboardingStatusValue["COMPLETED"] = "completed";
    OnboardingStatusValue["ABANDONED"] = "abandoned";
})(OnboardingStatusValue || (OnboardingStatusValue = {}));
export var OnboardingStepEventTypeValue;
(function (OnboardingStepEventTypeValue) {
    OnboardingStepEventTypeValue["ENTERED"] = "entered";
    OnboardingStepEventTypeValue["COMPLETED"] = "completed";
    OnboardingStepEventTypeValue["EXITED"] = "exited";
})(OnboardingStepEventTypeValue || (OnboardingStepEventTypeValue = {}));
export const KNOWN_ONBOARDING_STEP_IDS = [
    'fork',
    'goals',
    'company',
    'number',
    'integrations',
    'plan',
    'billing',
    'recap',
    'done',
];
//# sourceMappingURL=onboarding.js.map